import { peopleCardRouteCleanup, peopleCardRouterHandler } from './peopleCardRouteHandlers';
import { registerRoute } from 'owa-router';

export default function registerPeopleCardRoutes(defaultRoute: string = '/') {
    // handle the /card/new or /card/edit cases
    registerRoute(
        defaultRoute + 'card/:routeIdType',
        peopleCardRouterHandler,
        peopleCardRouteCleanup
    );
    registerRoute(
        defaultRoute + 'card/:routeIdType/:routeId',
        peopleCardRouterHandler,
        peopleCardRouteCleanup
    );
    registerRoute(
        defaultRoute + 'card/:routeIdType/:routeId/:view',
        peopleCardRouterHandler,
        peopleCardRouteCleanup
    );
}
